import PropTypes from 'prop-types';

import { FadeInAnimation, Shapes } from '../../shared';

import { parseTitle } from '../../../../utils/title-parser';

import Image from '../../shared/image.component';

import useResponsive from '../../../../utils/responsive';

const HeroSection = (props) => {
    
    const isMainHeaderOne = true;
    const { isMobile, isTablet } = useResponsive();

    const renderImageSection = () => {
        return (
            <div className='hero-section-image-container'>
                {renderImageSectionDesktop()}
                {renderImageSectionMobile()}
            </div>
        );
    };

    const renderImageSectionDesktop = () => {
        if (!isMobile || !isTablet) {
            return (
                <>
                    <Shapes
                        isPair
                        isLargeDark
                        degrees="30deg"
                        speed={0.15}
                        smallMargins={{ width: 50, height: 25 }}
                        largeMargins={{ width: 86, height: 43 }}
                        distanceBetween={{ width: '0%', height: '15%' }}
                        containerMargins={{ left: '67.5%', top: '17%' }}
                        zIndex={2}
                    />
                    <Shapes
                        isDots
                        speed={-0.07}
                        containerMargins={{
                            top: '11.5%',
                            left: '15.5%',
                        }}
                        smallMargins={{ width: '40%' }}
                        zIndex={1}
                    />

                    <div className='hero-section-hero-image-container'>

                        <Image className='hero-section-app-hero-image' src={props.imgSrc} alt={props.imgAlt} isOldImage />

                    </div>

                </>
            );
        }
        return null;
    };

    const renderImageSectionMobile = () => {
        if (isMobile && isTablet) {
            return (
                <>
                    <Shapes
                        isPair
                        isLargeDark
                        degrees="30deg"
                        speed={0.15}
                        smallMargins={{ width: 21.26, height: 10.63 }}
                        largeMargins={{ width: 36.57, height: 18.28 }}
                        distanceBetween={{ width: '0%', height: '15%' }}
                        containerMargins={{ left: '65.5%', top: '22%' }}
                        zIndex={2}
                    />
                    <Shapes
                        isDots
                        speed={-0.05}
                        containerMargins={{
                            top: '8%',
                            left: '-4%',
                        }}
                        smallMargins={{ width: '50%' }}
                        zIndex={1}
                    />

                    <div className='hero-section-hero-image-container'>

                        <Image className='hero-section-app-hero-image' src={props.imgSrc} alt={props.imgAlt} isOldImage />

                    </div>

                </>
            );
        }

        return null;

    };

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div className='main-grid-container hero-section-grid-container-app'>

                <div className='main-grid-item main-grid-md-4'>

                    <div className='hero-section-heading'>
                        {parseTitle(props.title, props.id, isMainHeaderOne)}
                    </div>

                    <FadeInAnimation>

                        <h5 id="home_subheading">{props.subheading}</h5>

                        <p id="home_hero_paragraph" className='hero-section-app-paragraph'>
                            {props.paragraph}
                        </p>

                        <p id="home_hero_paragraph_two" className='hero-section-app-paragraph'>
                            {props.paragraphTwo}
                        </p>

                    </FadeInAnimation>

                </div>

                <div className='main-grid-item main-grid-md-8'>
                    {renderImageSection()}
                </div>

            </div>

        </div>

    );
};

export default HeroSection;

HeroSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    id: PropTypes.string,
    subheading: PropTypes.string,
    paragraphTwo: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
};

